import { render } from "./sign-up.vue?vue&type=template&id=1f7cbfcb&ts=true"
import script from "./sign-up.vue?vue&type=script&lang=ts"
export * from "./sign-up.vue?vue&type=script&lang=ts"

import "./sign-up.vue?vue&type=style&index=0&id=1f7cbfcb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__